import symbol from '@/data/currency.js'

export default {
  format (data, useSymbol = true, noComma = false) {
    let locale = 'en-US'
    let options = {
      style: 'currency',
      currency: data.code,
      currencyDisplay: 'code'
    }

    let currency = new Intl.NumberFormat(locale, options)
    let newVal = currency.format(data.val).replace(data.code, "").trim()
    if (noComma) newVal = newVal.replaceAll(',', '')
    return useSymbol ? `${symbol[data.code]} ${newVal}` : newVal
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/currency.js